import ActivateProviderMobileScreen from './container'
export { ActivateProviderMobileScreen }
export default ActivateProviderMobileScreen